import { CapoPlugin } from "/builds/connection-ticketing/boats-spa/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];